import validator from 'validator';
import { isEmpty } from '../isEmpty';
import { regularExpressions } from '../../Constants/regularExpressions';
import { authenticationErrorMessages } from '../../Constants/errorMessages';

export const validateGymSignUpFields = data => {
    let errors = {};
    let fields = { ...data };

    fields.fullName = !isEmpty(data.fullName) ? data.fullName : '';
    fields.email = !isEmpty(data.email) ? data.email : '';
    fields.password = !isEmpty(data.password) ? data.password : '';
    fields.passwordConfirmation = !isEmpty(data.passwordConfirmation) ? data.passwordConfirmation : '';
    fields.phoneNumber = !isEmpty(data.phoneNumber) ? data.phoneNumber : '';

    // full name
    if (validator.isEmpty(fields.fullName)) errors.fullName = authenticationErrorMessages.FULL_NAME_REQUIRED;
    if (!validator.isLength(fields.fullName, 2)) errors.fullName = authenticationErrorMessages.FULL_NAME_TOO_SHORT;

    // email
    if (validator.isEmpty(fields.email)) errors.email = authenticationErrorMessages.EMAIL_REQUIRED;
    if (!validator.isEmail(fields.email)) errors.email = authenticationErrorMessages.ENTER_VALID_EMAIL;

    // password
    if (validator.isEmpty(fields.password)) errors.password = authenticationErrorMessages.PASSWORD_REQUIRED;
    if (!validator.isLength(fields.password, 8, 32))
        errors.password = authenticationErrorMessages.PASSWORD_LENGTH_ERROR;

    // password confirmation
    if (validator.isEmpty(fields.passwordConfirmation))
        errors.passwordConfirmation = authenticationErrorMessages.PASSWORD_CONFIRMATION_REQUIRED;
    if (!errors.password && !validator.matches(fields.passwordConfirmation, fields.password))
        errors.passwordConfirmation = authenticationErrorMessages.PASSWORDS_DO_NOT_MATCH;

    // phone number
    if (validator.isEmpty(fields.phoneNumber)) errors.phoneNumber = authenticationErrorMessages.PHONE_NUMBER_REQUIRED;
    if (!validator.matches(fields.phoneNumber, regularExpressions.PHONE_NUMBER_PATTERN))
        errors.phoneNumber = authenticationErrorMessages.ENTER_VALID_PHONE_NUMBER;

    return {
        errors,
        fields,
        isValidationPassed: isEmpty(errors),
    };
};



// WEBPACK FOOTER //
// ./src/Validation/Authentication/RegisterGym.js